import {Outlet} from 'react-router'
import PropTypes from 'prop-types'

import {NewSupplierLayout as SupplierLayout} from '~/react/layouts/SupplierLayout'
import Loading from '~/react/components/Loading'

export const Layout = ({supplierLayoutState, variant}) => {
  return (
    <SupplierLayout state={supplierLayoutState} variant={variant}>
      <Loading>
        <Outlet />
      </Loading>
    </SupplierLayout>
  )
}

Layout.defaultProps = {
  variant: 'primary',
}

Layout.propTypes = {
  supplierLayoutState: PropTypes.string.isRequired,
  variant: PropTypes.string,
}
